import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import AdminPage from "@/pages/AdminPage";
import CareersPage from "@/pages/CareersPage";
import NotFound from "@/pages/NotFound";
import ServicesIndex from "@/pages/seo/ServicesIndex";
import ServicePage from "@/pages/seo/ServicePage";
import LocationsIndex from "@/pages/seo/LocationsIndex";
import CityPage from "@/pages/seo/CityPage";
import BlogIndex from "@/pages/seo/BlogIndex";
import BlogPost from "@/pages/seo/BlogPost";
import CaseStudiesIndex from "@/pages/seo/CaseStudiesIndex";
import CaseStudyPage from "@/pages/seo/CaseStudyPage";
import PageViewTracker from "@/components/PageViewTracker";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageViewTracker />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/services" element={<ServicesIndex />} />
          <Route path="/services/:slug" element={<ServicePage />} />
          <Route path="/locations" element={<LocationsIndex />} />
          <Route path="/locations/:slug" element={<CityPage />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/work" element={<CaseStudiesIndex />} />
          <Route path="/work/:slug" element={<CaseStudyPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#f5f5dc",
            borderRadius: 0,
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
